import React from "react";
import { Diamond } from "lucide-react";
import { useTableComparison } from "./TableComparisonContext";

/** Header diamond — opens comparison dialog when rows are selected. */
export const TableCompareTrigger = ({ className = "" }) => {
  const comparison = useTableComparison();
  if (!comparison?.enabled) return null;

  return (
    <button
      type="button"
      className={`lovable-impact-header__compare ${className}`.trim()}
      disabled={comparison.selectedIds.length === 0}
      onClick={(e) => {
        e.stopPropagation();
        comparison.openDialog();
      }}
      title={
        comparison.selectedIds.length === 0
          ? "Select rows to compare (max 5)"
          : `Compare ${comparison.selectedIds.length} rows`
      }
    >
      <Diamond className="lovable-impact-header__compare-icon" strokeWidth={2.5} />
    </button>
  );
};

export default TableCompareTrigger;
